"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TransactionsCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _ui = require("../../ui");
var _transactions = require("../../transactions");
var _excluded = ["onViewAll", "onViewFull", "className", "title", "subtitle", "tableComponent"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var TransactionsCard = function TransactionsCard(_ref) {
  var onViewAll = _ref.onViewAll,
    onViewFull = _ref.onViewFull,
    className = _ref.className,
    title = _ref.title,
    subtitle = _ref.subtitle,
    TableComponent = _ref.tableComponent,
    transactionsTableProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = (0, _reactI18next.useTranslation)('libCommon'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, {
    width: "long",
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.CardHeader, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_ui.CardTitle, null, title), /*#__PURE__*/_react.default.createElement(_ui.SeeMore, {
    onClick: onViewAll
  }, t('seeAll'))), /*#__PURE__*/_react.default.createElement(_ui.CardSubtitle, null, subtitle)), /*#__PURE__*/_react.default.createElement(_ui.CardBody, {
    className: "d-flex flex-column pt-0 h-100"
  }, /*#__PURE__*/_react.default.createElement(_transactions.Transactions, _extends({
    cardComponent: _transactions.CardTransaction,
    tableComponent: TableComponent !== null && TableComponent !== void 0 ? TableComponent : _transactions.RecentTransactionsTable,
    onTransactionClick: onViewFull
  }, transactionsTableProps))));
};
exports.TransactionsCard = TransactionsCard;